import { customStaticSeoConfig, getApiToken } from "../utils/helpers/helpers";
import MarkdownRender from "../components/common/MarkdownRender";
import { KOTOKO_HISTORY_URL } from "../utils/constants/websiteUrls";
import { kClubHistoryURL } from "../utils/constants/apiUrls";
import { apiWrapper } from "../utils/api/apiWrapper";
import { TWELVE_MONTHS_REFRESH_INTERVAL_SECONDS } from "../utils/constants/numbers";
import HeroSlider from "../components/common/slider/HeroSlider";
import { TabNoData } from "../components/common/NoData";
import NoTextNavBackground from "../components/common/NoTextNavBackground";

const AsanteKotokoHistory = ({ kotokoHistory }) => {
  // SAFE FIX: Provide an empty object default to prevent top-level destructuring crashes
  const { history = {}, history_images: historyImages = [] } =
    kotokoHistory || {};

  // SAFE FIX: Protect deep lookups against empty nested properties
  const {
    title: historyTitle = "Club History",
    club_history: clubHistory = "",
  } = history || {};

  // SAFE FIX: Protected map operation against uninitialized array vectors
  const historyGallery = (historyImages || []).map(function (item, index) {
    return item?.image || "";
  });

  const url = KOTOKO_HISTORY_URL;

  return (
    <>
      {customStaticSeoConfig("Asante Kotoko History")}

      <NoTextNavBackground />

      {clubHistory === "" && (
        <>
          <TabNoData />
        </>
      )}

      {clubHistory !== "" && (
        <>
          <HeroSlider
            gallery={historyGallery}
            title="Asante Kotoko's story: The greatest ever told."
            showScrollToRead={true}
          />

          <MarkdownRender
            title={historyTitle}
            caption={
              "Delve into the history of Asante Kotoko including the club's history by decade."
            }
            url={url}
            markdownData={clubHistory}
          />
        </>
      )}
    </>
  );
};

export default AsanteKotokoHistory;

export const getStaticProps = async (context) => {
  const token = getApiToken();
  const kotokoHistory = await apiWrapper.get(kClubHistoryURL, token);

  return {
    props: {
      // SAFE FIX: Fallback to an empty object wrapper to protect child node evaluations
      kotokoHistory: kotokoHistory?.data || {},
    },
    revalidate: TWELVE_MONTHS_REFRESH_INTERVAL_SECONDS,
  };
};
